import React from 'react';
import { Link } from 'react-router-dom';
import { Box, Text, Stack, Flex } from '@atlaskit/primitives';
import Button from '@atlaskit/button';
import { ProgressIndicator } from '@atlaskit/progress-indicator';
import { getCompanyNameRoute } from '@css-xp/ppc-utils';
import { InfoPanel } from '@css-xp/base';

export const CreateCustomerSuccess = ({
  onClose,
  formStages,
  companyName,
  transactionAccountId,
}: {
  onClose: () => void;
  formStages: string[];
  companyName: string;
  transactionAccountId: string;
}) => {
  const companyNamePath = getCompanyNameRoute({ txaId: transactionAccountId, companyName });

  return (
    <>
      <InfoPanel
        type="success"
        message={
          <Stack space="space.100">
            <Text weight="bold">The customer has been created.</Text>
            <Stack>
              <Text>Next step: Add a billing profile</Text>
              <Text>A customer account will only be active once it’s linked to a billing profile.</Text>
            </Stack>
            <Link
              to={`${companyNamePath}/#billing-profiles`}
              data-testid="add-billing-profile-link"
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
            >
              Add billing profile
            </Link>
          </Stack>
        }
      />
      <Box id="footer">
        <Flex justifyContent="space-between" alignItems="center">
          <Box />
          <ProgressIndicator appearance="primary" selectedIndex={2} values={formStages} />
          <Button appearance="default" onClick={onClose}>
            Close
          </Button>
        </Flex>
      </Box>
    </>
  );
};
